import * as d3 from 'd3-selection'
import * as shape from 'd3-shape'
import * as array from 'd3-array'
import * as scale from 'd3-scale'
import { interpolate } from 'd3-interpolate'

export default function (id, defs, dimensions, startAngle, onRotate, onEnd) {
  var needleStartingWidth = 2.3
    , needleEndingWidth = 0.8
    , needleTipRoundness = 0.93
    , needleLength = (dimensions.width / 2) - 3.8
    , baseRadius = (dimensions.width / 2) / 6.4
    , startingNeedleDistance =  -baseRadius + 1 // start 1 unit inside of the base
    , needleShadowOffset = [0,3]
    , needleShadowBlur = 1.5

  var draw = function (selection) {
    selection.each(function (data) {
      var line = shape.line()
                      .curve(shape.curveCardinal.tension(needleTipRoundness))
        , lineData = data.value && !isNaN(data.value.raw) && data.thresholds && data.thresholds.length > 0 // Show pointer if we have a raw value and thresholds
                                                          ? [ [needleStartingWidth/2, startingNeedleDistance],
                                                            [needleEndingWidth/2, -needleLength],
                                                            [needleEndingWidth/-2, -needleLength],
                                                            [needleStartingWidth/-2, startingNeedleDistance] ]
                                                          : []
        , scaler = scale.scaleLinear()
                        .domain(array.extent(data.thresholds || [0, 1]))
                        .range([startAngle, startAngle * -1])
                        .clamp(true)

      // Add the linear gradients
      var defsPointer = defs.selectAll('g.defs-pointer')
                            .data([data])
        , defsEnter = defsPointer.enter()
                                 .append('g')
                                   .attr('class', 'defs-pointer')
        , _defsPointer = defsEnter.merge(defsPointer)

      // Add the shadow for the needle.
      var shadow = defsEnter.selectAll('.pointer-shadow')
                            .data([data])
                            .enter()
                            .append('filter')
                              .attr('id', 'pointer-shadow-' + id)
                              .attr('x', '-150%')
                              .attr('y', '-25%')
                              .attr('width', '400%')
                              .attr('height', '150%')

      shadow.append('feOffset')
              .attr('dx', needleShadowOffset[0])
              .attr('dy', needleShadowOffset[1])
              .attr('in', 'SourceAlpha')
              .attr('result', 'offOut')
      shadow.append('feGaussianBlur')
              .attr('result', 'blurOut')
              .attr('stdDeviation', needleShadowBlur)
              .attr('in', 'offOut')

      var bg = _defsPointer.selectAll('.pointer-base-gradient')
                           .data([data])
        , rg = bg.enter().append('radialGradient')
                           .attr('class', 'pointer-base-gradient')
                           .attr('cx', '50%')
                           .attr('cy', '10%')
                           .attr('r', '40%')
                           .attr('fx', '50%')
                           .attr('fy', '10%')

      rg.append('stop').attr('offset', '0%')
      rg.append('stop').attr('offset', '100%')

      rg.merge(bg)
        .attr('id', id + '-pointer-base')

      var group = d3.select(this)
                    .selectAll('g.pointers').data([data])
        , enter = group.enter()
                       .append('g')
                        .attr('class', 'pointers')
        , pointers = enter.merge(group)
                          .selectAll('g.pointers path')
                          .data(lineData.length ? [lineData, lineData] : []) // pointer shape only exists if we have line data

      enter.append('circle')
             .attr('cx', 0)
             .attr('cy', 0)
             .attr('r', baseRadius)
             .attr('fill', 'url(#' + id + '-pointer-base)')

      pointers.exit().remove()

      pointers.enter()
              .append('path')
              .attr('transform', () => `rotate(${scaler(data.value && data.value.raw || 0)})`)
              .merge(pointers)
              .attr('d', line)
              .attr('filter', function (d, i) {
                return i === 0 ? 'url(#pointer-shadow-' + id + ')' : ''
              })
              .attr('class', function (d, i) {
                return i === 0 ? 'pointer-shadow' : 'pointer'
              })

      group.selectAll('path')
           .transition()
           .duration(300) // todo config
           .attrTween('transform', function (d, i, v) {
             var from = d3.select(this).attr('transform')
               , interpolater = interpolate(parseFloat(from.substr(7)), scaler(data.value && data.value.raw || 0))

             return function (t) {
               let angle = (lineData.length && interpolater(t)) || null

               if (angle) {
                 onRotate(angle, scaler.invert(angle))
               }
               return `rotate(${angle || 0})`
             }
           })
           .on('end', onEnd)

    })
  }

  // adjust the viewbox height based on what we're drawing
  dimensions.viewbox.height += baseRadius

  return draw
}
